import { useEffect, useState } from "react";
import { Status } from "../interfaces/Status";
import Column from "./Column";
import ColumnDynamic from "./ColumnDynamic";

interface IProps {
	statusKey: string;
	columnKeys: Status[];
	columnClassName?: string;
	filter?: any;
	search?: any;
	reset?: boolean;
	renderComponent(data: any): any;
	changeEvent?(id: any, key: string): void;
	onBottom: (key: Status, page: number, cb: any) => void;
}

const KanbanDynamic = (props: IProps) => {
	const [reset, setReset] = useState<boolean>(false);

	const [data, setData] = useState<any>({});
	const [keys, setKeys] = useState<Status[]>(props.columnKeys);
	const [startColumn, setStartColumn] = useState<any>({});
	const [endColumn, setEndColumn] = useState<any>({});

	const setDataColumn = (dataColumn: any[], key: string) => {
		if (dataColumn.length > data[key].length) {
			var changedItem = dataColumn.findIndex(
				(item) => item[props.statusKey].name !== key
			);
			dataColumn[changedItem][props.statusKey].name = key;
			if (props.changeEvent) props.changeEvent(dataColumn[changedItem], key);
		}

		if (dataColumn.length > data[key].length) {
			setStartColumn({ key, data: [...dataColumn] });
		}
		if (dataColumn.length < data[key].length) {
			setEndColumn({ key, data: [...dataColumn] });
		}
	};

	const onBottom = (key: Status, page: number) => {
		props.onBottom(key, page, onCB);
	};

	const onCB = (key: string, resdata: any[]) => {
		setData((prevState: any) => ({ ...prevState, [key]: resdata }));
	};

	useEffect(() => {
		setReset(!reset);
	}, [props.reset]);

	useEffect(() => {
		setReset(!reset);
	}, [props.filter, props.search]);

	useEffect(() => {
		var eventData = { ...data };
		eventData[startColumn.key] = startColumn.data;
		eventData[endColumn.key] = endColumn.data;
		setData({ ...eventData });
	}, [endColumn]);

	useEffect(() => {
		setKeys(props.columnKeys);
		var eventData: any = {};
		for (let t of props.columnKeys) eventData[t.name] = [];
		setData(eventData);
	}, [props.columnKeys]);

	return (
		<div className="flex w-full gap-10 overflow-auto">
			{keys.map((key, i: number) => (
				<ColumnDynamic
					data={data[key.name] ? data[key.name] : []}
					setData={setDataColumn}
					columnKey={key.name}
					className={props.columnClassName}
					key={`canban-col-${i}`}
					onBottom={(page: number) => onBottom(key, page)}
					index={i}
					reset={reset}
				>
					{data[key.name].map((item: any) => props.renderComponent(item))}
				</ColumnDynamic>
			))}
		</div>
	);
};

export default KanbanDynamic;
